import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { useNavigate } from "react-router-dom";
import { Collapse, Button } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AppShortcutOutlinedIcon from "@mui/icons-material/AppShortcutOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import AppsOutlinedIcon from "@mui/icons-material/AppsOutlined";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import CakeOutlined from "@mui/icons-material/CakeOutlined";
import CelebrationOutlined from "@mui/icons-material/CelebrationOutlined";
import IcecreamIconOutlined from "@mui/icons-material/IcecreamOutlined";
import QueuePlayNextOutlinedIcon from "@mui/icons-material/QueuePlayNextOutlined";
import InventoryOutlinedIcon from "@mui/icons-material/InventoryOutlined";
import DeliveryDiningOutlinedIcon from "@mui/icons-material/DeliveryDiningOutlined";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import TaxIcon from "@mui/icons-material/PriceCheck";
import AllInboxOutlinedIcon from "@mui/icons-material/AllInboxOutlined";
import ScaleOutlinedIcon from "@mui/icons-material/ScaleOutlined";
import {
  CancelOutlined,
  DiscountOutlined,
  ExitToAppOutlined,
  LocationCity,
  PercentOutlined,
  PlaceOutlined,
  PrecisionManufacturingOutlined,
  RedeemOutlined,
  SmsFailedOutlined,
  SportsMotorsportsOutlined,
  StoreOutlined,
  StorefrontOutlined,
  Inventory2Outlined,
  ForumOutlined,
  CampaignOutlined,
} from "@mui/icons-material";
import AccountMenu from "./account";
import Notification from "./notification";
import ChatNotification from "./ChatNotification";
import AiCopilotDrawer from "../../components/ai-copilot/AiCopilotDrawer";
import SavingsOutlinedIcon from "@mui/icons-material/SavingsOutlined";
import PhotoOutlinedIcon from "@mui/icons-material/PhotoOutlined";
import RecordVoiceOverOutlinedIcon from "@mui/icons-material/RecordVoiceOverOutlined";
import { useSelector } from "react-redux";
import QuestionAnswerOutlinedIcon from "@mui/icons-material/QuestionAnswerOutlined";
import TuneIcon from "@mui/icons-material/Tune";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import SortIcon from "@mui/icons-material/Sort";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import RuleIcon from "@mui/icons-material/Rule";
import LibraryAddIcon from "@mui/icons-material/LibraryAdd";
import AdsClickIcon from "@mui/icons-material/AdsClick";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import SmartToyOutlinedIcon from "@mui/icons-material/SmartToyOutlined";
import NewReleasesIcon from "@mui/icons-material/NewReleases";
import SendTimeExtensionOutlinedIcon from "@mui/icons-material/SendTimeExtensionOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import * as MuiIcons from "@mui/icons-material";
import { useDispatch } from "react-redux";
import axios from "axios";
import {
  storeAllRegionList,
  storeAllBannerList,
  toggleTheme,
} from "../../redux/counterSlice";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import DateRangeIcon from "@mui/icons-material/DateRange";
import BoltOutlinedIcon from '@mui/icons-material/BoltOutlined';
import { keyframes } from "@mui/system";
import QrCodeIcon from "@mui/icons-material/QrCode";
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';
import { useVoiceNavigation, VoiceNavButton } from "./Usevoicenavigation";
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import RemoveShoppingCartOutlinedIcon from '@mui/icons-material/RemoveShoppingCartOutlined';
import PivotTableChartOutlinedIcon from '@mui/icons-material/PivotTableChartOutlined';

const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

// Static menu for fallback and icon reference
const mainMenu = [
  {
    key: "dashboard",
    text: "Dashboard",
    icon: BarChartOutlinedIcon,
    subMenu: false,
    open: false,
    route: "/dashboard",
    roles: ["admin", "shop", "dispatch"],
    items: [],
  },
  {
    key: "home",
    text: "Home",
    icon: HomeOutlinedIcon,
    subMenu: true,
    open: false,
    roles: ["admin"],
    items: [
      {
        key: "home-section",
        text: "Home Sections",
        route: "/home-region",
        icon: AppShortcutOutlinedIcon,
      },
      {
        key: "configuration",
        text: "Configuration",
        route: "/configuration",
        icon: TuneIcon,
      },
    ],
  },
  {
    key: "provisioning",
    text: "Provisioning",
    icon: AppsOutlinedIcon,
    subMenu: true,
    open: false,
    roles: ["admin"],
    items: [
      {
        key: "category",
        text: "Category",
        route: "/category",
        icon: CategoryOutlinedIcon,
      },
      {
        key: "sub-category",
        text: "Sub Category",
        route: "/sub-category",
        icon: AccountTreeOutlinedIcon,
      },
      {
        key: "flavour",
        text: "Flavour",
        route: "/flavour",
        icon: IcecreamIconOutlined,
      },
      {
        key: "products",
        text: "Products",
        route: "/products",
        icon: CakeOutlined,
      }, 
      {
        key: "fast-delivery",
        text: "Fast Delivery",
        route: "/fast-delivery",
        icon: BoltOutlinedIcon,
      },
       {
        key: "category-code",
        text: "Category Code",
        route: "/Category-code",
        icon: QrCodeIcon,
      },
      {
        key: "addons",
        text: "Addons",
        route: "/addons",
        icon: CelebrationOutlined,
      },
      {
        key: "bulk-provision",
        text: "Bulk Provision",
        route: "/bulk-provision",
        icon: Inventory2Outlined,
      },
      {
        key: "photo-cakes",
        text: "Photo Shape",
        route: "/custom-design",
        icon: PhotoOutlinedIcon,
      },
      {
        key: "add-units",
        text: "Units",
        route: "/units",
        icon: AllInboxOutlinedIcon,
      },
      {
        key: "weight",
        text: "Weight",
        route: "/weight",
        icon: ScaleOutlinedIcon,
      },
      {
        key: "tax",
        text: "Tax",
        route: "/tax",
        icon: TaxIcon,
      },
    ],
  },
  {
    key: "order",
    text: "Order",
    icon: QueuePlayNextOutlinedIcon,
    subMenu: true,
    open: false,
    roles: ["admin"],
    items: [
      {
        key: "order-list",
        text: "Ongoing Orders",
        route: "/order-list",
        icon: InventoryOutlinedIcon,
      },
      {
        key: "delivered-order-list",
        text: "Delivered Orders",
        route: "/delivered-order-list",
        icon: DeliveryDiningOutlinedIcon,
      },
      {
        key: "cancelled-order-list",
        text: "Cancelled Orders",
        route: "/cancelled-order-list",
        icon: CancelOutlined,
      },
      {
        key: "failed-order-list",
        text: "Failed Orders",
        route: "/failed-order-list",
        icon: SmsFailedOutlined,
      },
    ],
  },
  {
    key: "external",
    text: "External",
    icon: ExitToAppOutlined,
    subMenu: true,
    open: false,
    roles: ["admin"],
    items: [
      {
        key: "dispatch-panel",
        text: "Dispatch Panel",
        route: "/dispatch-panel",
        icon: PrecisionManufacturingOutlined,
      },
      {
        key: "shop-panel",
        text: "Shop Panel",
        route: "/shop-panel",
        icon: StoreOutlined,
      },
      {
        key: "driver-panel",
        text: "Driver Panel",
        route: "/driver-panel",
        icon: SportsMotorsportsOutlined,
      },
    ],
  },
  {
    key: "shop",
    text: "Shop",
    icon: StoreOutlined,
    subMenu: false,
    open: false,
    route: "/shop-panel",
    roles: ["shop"],
    items: [],
  },
  {
    key: "reports",
    text: "Reports",
    icon: SortIcon,
    subMenu: false,
    open: false,
    route: "/sales-report",
    roles: ["shop"],
    items: [],
  },
  {
    key: "order",
    text: "Order",
    icon: InventoryOutlinedIcon,
    subMenu: false,
    open: false,
    route: "/order-list",
    roles: ["shop"],
    items: [],
  },
  {
    key: "dispatch",
    text: "Dispatch",
    icon: PrecisionManufacturingOutlined,
    subMenu: false,
    open: false,
    route: "/dispatch-panel",
    roles: ["dispatch"],
    items: [],
  },
  {
    key: "discount",
    text: "Discount",
    icon: PercentOutlined,
    subMenu: true,
    open: false,
    roles: ["admin"],
    items: [
      {
        key: "discount",
        text: "Discount",
        route: "/discount",
        icon: DiscountOutlined,
      },
      {
        key: "category-discount",
        text: "Category Discount",
        route: "/category-discount",
        icon: CategoryOutlinedIcon,
      },
      {
        key: "product-discount",
        text: "Product Discount",
        route: "/product-discount",
        icon: CakeOutlined,
      },
      {
        key: "customer-discount",
        text: "Customer Discount",
        route: "/customer-discount",
        icon: SavingsOutlinedIcon,
      },
      {
        key: "customer-promo",
        text: "Custom Promo",
        route: "/customer-promo",
        icon: RecordVoiceOverOutlinedIcon,
      },
      {
        key: "promo",
        text: "Promo",
        route: "/promo",
        icon: RedeemOutlined,
      },
      {
        key: "flat-price",
        text: "Flat Price",
        route: "/flat-price",
        icon: PaidOutlinedIcon,
      },
      {
        key: "cart-offers",
        text: "Cart Offers",
        route: "/cart-offers",
        icon: RedeemOutlined,
      },
      {
        key: "SuggestionProduct",
        text: "Suggested",
        route: "/SuggestionProduct",
        icon: QuestionAnswerOutlinedIcon,
      },
    ],
  },
  {
    key: "region",
    text: "Region",
    icon: LocationCity,
    subMenu: true,
    open: false,
    roles: ["admin"],
    items: [
      {
        key: "city",
        text: "City",
        route: "/city",
        icon: LocationCity,
      },
      {
        key: "location",
        text: "Location",
        route: "/location",
        icon: PlaceOutlined,
      },
      {
        key: "shop",
        text: "Shop",
        route: "/shop",
        icon: StorefrontOutlined,

      },
      {
        key: "dispatch",
        text: "Dispatch",
        route: "/dispatch",
        icon: PrecisionManufacturingOutlined,

      },
      {
        key: "slot",
        text: "Slot",
        route: "/slotBlock",
        icon: EventAvailableIcon,
      },
    ],
  },
  {
    key: "engagement",
    text: "Engagement",
    icon: SendTimeExtensionOutlinedIcon,
    subMenu: true,
    open: false,
    roles: ["admin"],
    items: [
      {
        key: "Campaign-Bulk-msg",
        text: "Campaign",
        route: "/campaign",
        icon: CampaignOutlined,
      },
    ],
  },
  {
    key: "report",
    text: "Reports",
    icon: AssignmentOutlinedIcon,
    subMenu: true,
    open: false,
    roles: ["admin"],
    items: [
      {
        key: "sales-report",
        text: "Sales Report",
        route: "/sales-report",
        icon: SortIcon,
      },
      {
        key: "yearly-report",
        text: "Yearly Report",
        route: "/yearly-report",
        icon: DateRangeIcon,
      },
      {
        key: "product-report",
        text: "Product Report",
        route: "/product-report",
        icon: AssessmentOutlinedIcon,
      },
      {
        key: "cancelled-order-report",
        text: "Cancelled Order",
        route: "/cancelled-order-report",
        icon: RemoveShoppingCartOutlinedIcon,
      },
      {
        key: "pivot-report",
        text: "Report",
        route: "/pivot-report",
        icon: PivotTableChartOutlinedIcon,
      },
    ],
  },
  {
    key: "admin",
    text: "Admin",
    icon: ManageAccountsIcon,
    subMenu: true,
    open: false,
    roles: ["admin"],
    items: [
      {
        key: "team",
        text: "Team",
        route: "/team",
        icon: SupervisorAccountIcon,
      },
      {
        key: "menu",
        text: "Menu",
        route: "/menuCreate",
        icon: LibraryAddIcon,
      },
      {
        key: "role",
        text: "Role",
        route: "/role",
        icon: RuleIcon,
      },
      {
        key: "ai-copilot",
        text: "AI Copilot",
        route: "/ai-copilot",
        icon: SmartToyOutlinedIcon,
      },
    ],
  },
];

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function SideNav() {
  const userData = useSelector((state) => state.counter?.userData);
  const themeMode = useSelector((state) => state.counter?.themeMode ?? "light");
  const theme = useTheme();
  const navigate = useNavigate();
  const [menuItems, setMenuItems] = React.useState([]);
  const [open, setOpen] = React.useState(true);
  const dispatch = useDispatch();
  const allRegions = useSelector((state) => state.counter.allRegionList);
  const allBanners = useSelector((state) => state.counter.allBannerList);
  const hasFetchedBanners = React.useRef(false);
  // console.log("region", allRegions);
  // console.log("bnners", allBanners);
  const [expiringBanners, setExpiringBanners] = React.useState([]);
  const [showTodo, setShowTodo] = React.useState(false);

  // Get user role
  const getUserRole = () => {
    // ✅ First check if we have role data from API
    if (userData?.role?.role_name) {
      const roleName = userData.role.role_name.toLowerCase();
      if (roleName === "shop") return "shop";
      if (roleName === "dispatch") return "dispatch";
      return "admin"; // Default to admin for "Admin" role
    }

    // Fallback to session storage
    const loginType = sessionStorage.getItem("loginType");
    if (loginType) return loginType;

    const currentPath = window.location.pathname;
    if (
      currentPath.includes("/login/shop") ||
      sessionStorage.getItem("lastLoginPath")?.includes("shop")
    ) {
      sessionStorage.setItem("loginType", "shop");
      return "shop";
    } else if (
      currentPath.includes("/login/dispatch") ||
      sessionStorage.getItem("lastLoginPath")?.includes("dispatch")
    ) {
      sessionStorage.setItem("loginType", "dispatch");
      return "dispatch";
    } else if (
      currentPath.includes("/login/admin") ||
      sessionStorage.getItem("lastLoginPath")?.includes("admin")
    ) {
      sessionStorage.setItem("loginType", "admin");
      return "admin";
    }

    return "admin";
  };

  const userRole = getUserRole();

  // Static menu fallback function
  const getStaticMenusByRole = (role) => {
    return mainMenu.filter((item) => item.roles.includes(role));
  };

  // Build menu from API - group children under parent names with static icons
  const buildMenuStructure = (apiMenus) => {
    console.log("Building menu from API:", apiMenus);

    // Create static menu lookup by name
    const staticMenuMap = new Map();
    mainMenu.forEach((menu) => {
      staticMenuMap.set(menu.text.toLowerCase(), menu);
    });

    // Group menus by parent
    const parentGroups = new Map();

    apiMenus.forEach((menu) => {
      if (!menu.permissions || !menu.permissions.view) {
        console.log("Skipping menu (no view permission):", menu.menu_name);
        return;
      }
      // ✅ SUPER ADMIN ONLY: Skip Reports and Admin sections for non-super-admin users
      // const superAdminOnlySections = ["Reports", "Admin"];
      // if (superAdminOnlySections.includes(parentName)) {
      //   console.log(`Skipping super admin only section: ${parentName}`);
      //   return; // Skip this menu entirely
      // }
      // Get parent menu name
      const parentName = menu.parent_menu?.parent_menu_name || null;

      if (!parentName) {
        console.warn("Menu without parent:", menu);
        return;
      }

      // Create child menu item
      const childIcon = MuiIcons[menu.icon] || MuiIcons.HelpOutline;
      const childItem = {
        key: menu.menu_name.toLowerCase().replace(/\s+/g, "-"),
        text: menu.menu_name,
        icon: childIcon,
        route: menu.route || null,
        permissions: menu.permissions,
      };

      // Add to parent group
      if (!parentGroups.has(parentName)) {
        parentGroups.set(parentName, []);
      }
      parentGroups.get(parentName).push(childItem);
    });

    console.log("Parent groups created:", parentGroups);

    // Build final menu structure with parent icons from static menu
    const finalMenus = [];

    parentGroups.forEach((children, parentName) => {
      // Find matching static menu for icon
      const staticParent = staticMenuMap.get(parentName.toLowerCase());
      const parentIcon = staticParent
        ? staticParent.icon
        : MuiIcons.FolderOutlined;

      const parentMenu = {
        key: parentName.toLowerCase().replace(/\s+/g, "-"),
        text: parentName,
        icon: parentIcon,
        subMenu: true,
        open: false,
        items: children,
      };

      finalMenus.push(parentMenu);
      // console.log(`Created parent menu "${parentName}" with ${children.length} children`);
    });

    // console.log("Final menu structure:", finalMenus);
    return finalMenus;
  };

  // Build menu structure from API data or use static menu
  React.useEffect(() => {
    // console.log("=== SIDENAV DETAILED DEBUG ===");
    // console.log("1. Raw userData from Redux:", userData);
    // console.log("2. userData type:", typeof userData);
    // console.log("3. userData keys:", userData ? Object.keys(userData) : "null");

    // Check sessionStorage as backup
    const sessionData = sessionStorage.getItem("userData");
    // console.log("4. SessionStorage userData (raw):", sessionData);
    if (sessionData) {
      const parsed = JSON.parse(sessionData);
      // console.log("5. SessionStorage userData (parsed):", parsed);
      // console.log("6. SessionStorage isSuperAdmin:", parsed.isSuperAdmin);
      // console.log("7. SessionStorage role:", parsed.role);
    }

    // console.log("8. userData.isSuperAdmin:", userData?.isSuperAdmin);
    // console.log("9. Type of isSuperAdmin:", typeof userData?.isSuperAdmin);
    // console.log("10. Strict equality check (=== true):", userData?.isSuperAdmin === true);
    // console.log("11. Role object:", userData?.role);
    // console.log("12. Role name:", userData?.role?.role_name);

    // ✅ SUPER ADMIN CHECK with multiple fallbacks
    const isSuperAdminFromFlag = userData?.isSuperAdmin === true;
    // ✅ Check for "Super Admin" role (case-insensitive)
    const isSuperAdminFromRole =
      userData?.role?.role_name?.toLowerCase() === "super admin";
    const isSuperAdmin = isSuperAdminFromFlag || isSuperAdminFromRole;

    // console.log("13. Is super admin (from flag):", isSuperAdminFromFlag);
    // console.log("14. Is super admin (from role):", isSuperAdminFromRole);
    // console.log("15. Final isSuperAdmin decision:", isSuperAdmin);

    if (isSuperAdmin) {
      console.log("✅✅✅ SUPER ADMIN CONFIRMED - Loading full menu");
      const staticMenus = getStaticMenusByRole("admin");
      // console.log("16. Static menus count:", staticMenus.length);
      setMenuItems(staticMenus);
      return;
    }

    // console.log("17. Not super admin - checking API menus");

    // Check if menus property exists in userData (even if empty array)
    if (userData && "menus" in userData && Array.isArray(userData.menus)) {
      console.log("18. API menus found, count:", userData.menus.length);

      // If menus array is empty, user has no permissions - show nothing
      if (userData.menus.length === 0) {
        console.log("19. User has no menu permissions - showing empty menu");
        setMenuItems([]);
        return;
      }

      const builtMenus = buildMenuStructure(userData.menus);
      console.log("20. Built menus from API, count:", builtMenus.length);
      setMenuItems(builtMenus);
    } else {
      // No menus property in userData - use static fallback
      console.log("21. No API menus - using static menus for role:", userRole);
      const staticMenus = getStaticMenusByRole(userRole);
      setMenuItems(staticMenus);
    }
  }, [userData, userRole]);
  React.useEffect(() => {
    // ✅ Only run if regions are loaded
    if (!allRegions?.length) return;

    // ✅ Prevent multiple fetches
    if (hasFetchedBanners.current) return;

    const fetchAllBanners = async () => {
      try {
        // Map all regions to API calls using correct region_id
        const bannerPromises = allRegions.map((region) =>
          axios.get(`/bannerByRegion/${region.region_id}`),
        );

        const responses = await Promise.all(bannerPromises);

        // Log each region response for debugging
        responses.forEach((res, idx) => {
          console.log(
            `Region ${allRegions[idx].region_id} banner data:`,
            res.data,
          );
        });

        // Merge all banners into one array
        const mergedBanners = responses.flatMap((res) => res.data?.data || []);

        console.log("Merged banners:", mergedBanners);

        // Only store if we have banners
        if (mergedBanners.length > 0) {
          dispatch(storeAllBannerList(mergedBanners));
          hasFetchedBanners.current = true; // ✅ mark as fetched only on success
        } else {
          console.log("No banners available for any region yet.");
        }
      } catch (error) {
        console.error("Banner fetch error:", error);
        // Do not set hasFetchedBanners.current = true here, so it can retry next render
      }
    };

    fetchAllBanners();
  }, [allRegions, dispatch]); // run when regions are loaded
  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleMenuClick = (index) => {
    const updatedMenuItems = menuItems.map((item, i) => {
      if (i === index) {
        return { ...item, open: !item.open };
      } else {
        return { ...item, open: false };
      }
    });
    setMenuItems(updatedMenuItems);
  };
  React.useEffect(() => {
    if (!allBanners?.length) return;

    // ✅ Run immediately on load
    const expiring = getExpiringBanners(allBanners);
    if (expiring.length > 0) {
      setExpiringBanners(expiring);
      setShowTodo(true);
    } else {
      setShowTodo(false);
    }

    // Then keep checking every 1 minute
    const interval = setInterval(() => {
      const expiring = getExpiringBanners(allBanners);
      if (expiring.length > 0) {
        setExpiringBanners(expiring);
        setShowTodo(true);
      } else {
        setShowTodo(false);
      }
    }, 60 * 1000);

    return () => clearInterval(interval);
  }, [allBanners]);
  const parseLocalDateTime = (str) => {
    const [date, time] = str.split(" ");
    const [year, month, day] = date.split("-").map(Number);
    const [hours, minutes, seconds] = time.split(":").map(Number);
    return new Date(year, month - 1, day, hours, minutes, seconds);
  };
  // const getExpiringBanners = (banners) => {
  //   const now = new Date();
  //   return banners.filter((banner) => {
  //     if (!banner.banner_to_date) return false;
  //     const expiryDate = new Date(banner.banner_to_date);
  //     const diffMinutes = (expiryDate - now) / (1000 * 60);
  //     return diffMinutes <= 5 && diffMinutes > 0;
  //   });
  // };
  const getExpiringBanners = (banners) => {
    const now = new Date();

    return banners.filter((banner) => {
      if (!banner.banner_to_date) return false;

      const [date, time] = banner.banner_to_date.split(" ");
      const [year, month, day] = date.split("-").map(Number);
      const [hours, minutes, seconds] = time.split(":").map(Number);
      const expiryDate = new Date(
        year,
        month - 1,
        day,
        hours,
        minutes,
        seconds,
      );

      const diffMs = expiryDate - now;

      // Trigger if banner expires in next 8 minutes
      return diffMs > 0 && diffMs <= 6 * 60 * 1000;
    });
  };
  const regionMap = React.useMemo(() => {
    const map = new Map();
    allRegions.forEach((region) => {
      map.set(
        String(region.region_id),
        region.city?.name || region.state?.name || "Unknown",
      );
    });
    return map;
  }, [allRegions]);
  const shake = keyframes`
  0% { transform: translateX(0); }
  20% { transform: translateX(-3px); }
  40% { transform: translateX(3px); }
  60% { transform: translateX(-3px); }
  80% { transform: translateX(3px); }
  100% { transform: translateX(0); }
`;

const { listening, toggleListening, lastHeard } = useVoiceNavigation(
  menuItems,
  navigate,
  {
    announceMatches: true,
    onNoMatch: (transcript) => {
      console.log("No match found for:", transcript);
    },
  }
);

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        open={open}
        sx={{
          background:
            "radial-gradient(circle at 10% 20%, rgb(226, 37, 37) 0%, rgb(211, 49, 49) 82.8%)",
          height: "48px",
        }}
      >
        <Toolbar className="d-flex justify-content-between" variant="dense">
          <div className="d-flex align-items-center">
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              sx={{
                marginRight: 5,
                ...(open && { display: "none" }),
              }}
            >
              <MenuIcon />
            </IconButton>
          </div>
          <div className="d-flex align-items-center">
            {/* <VoiceNavButton listening={listening} onToggle={toggleListening} /> */}
            <IconButton
              color="inherit"
              onClick={() => dispatch(toggleTheme())}
              aria-label="toggle dark mode"
              sx={{ mr: 0.5 }}
            >
              {themeMode === "dark" ? (
                <LightModeOutlinedIcon fontSize="small" />
              ) : (
                <DarkModeOutlinedIcon fontSize="small" />
              )}
            </IconButton>
            {userRole === "admin" && <AiCopilotDrawer />}
            {userRole === "admin" && <ChatNotification />}
            <Notification />
            <AccountMenu />
          </div>
        </Toolbar>
      </AppBar>
      <Drawer variant="permanent" open={open}>
        <DrawerHeader>
          <img
            src={require("../../assets/logo.png")}
            alt=""
            width={100}
            className="m-auto"
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/dashboard")}
          />
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "rtl" ? (
              <ChevronRightIcon />
            ) : (
              <ChevronLeftIcon />
            )}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <>
          <List>
            {menuItems.map((item, index) => (
              <React.Fragment key={item.key}>
                {!item.subMenu ? (
                  <ListItem button onClick={() => navigate(item?.route)}>
                    <ListItemIcon>
                      <item.icon sx={{ color: "grey" }} />
                    </ListItemIcon>
                    <ListItemText primary={item.text} />
                  </ListItem>
                ) : (
                  <>
                    <ListItemButton onClick={() => handleMenuClick(index)}>
                      <ListItemIcon>
                        {item.open ? (
                          <ExpandMoreIcon />
                        ) : (
                          <item.icon sx={{ color: "grey" }} />
                        )}
                      </ListItemIcon>
                      <ListItemText primary={`${item.text}`} />
                    </ListItemButton>
                    <Collapse in={item.open} timeout="auto" unmountOnExit>
                      <List component="div" disablePadding>
                        {item.items?.map((subItem) => (
                          <ListItem
                            sx={{ px: open ? "32px" : "16px" }}
                            key={subItem.key}
                            button
                            onClick={() => navigate(subItem?.route)}
                          >
                            <ListItemIcon>
                              <subItem.icon sx={{ color: "red" }} />
                            </ListItemIcon>
                            <ListItemText primary={subItem.text} />
                          </ListItem>
                        ))}
                      </List>
                    </Collapse>
                  </>
                )}
              </React.Fragment>
            ))}
          </List>
        </>
      </Drawer>
      {showTodo && (
        <Box
          sx={{
            position: "fixed",
            bottom: 20,
            right: 20,
            bgcolor: "background.paper",
            color: "text.primary",
            p: 2,
            borderRadius: 2,
            zIndex: 2000,
            maxWidth: 400,
            boxShadow: 3,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 1,
            }}
          >
            <strong>Banners expiring soon:</strong>
            <WarningAmberOutlinedIcon
              sx={{
                color: "orange",
                animation: `${shake} 0.8s infinite`,
              }}
            />
          </Box>
          <Divider
            style={{ borderBottom: "2px solid black", marginBottom: "10px" }}
          />

          <ul style={{ margin: 0, paddingLeft: "16px" }}>
            {expiringBanners.map((b) => (
              <li key={b.id}>
                {b.banner_name} (Region: {regionMap.get(b.region_id)}) - Expires
                at {new Date(b.banner_to_date).toLocaleTimeString()}
              </li>
            ))}
          </ul>

          <Box
            sx={{ display: "flex", justifyContent: "flex-end", mt: 1, gap: 1 }}
          >
            <Button
              onClick={() => setShowTodo(false)}
              variant="contained"
              color="error"
            >
              Dismiss
            </Button>
            <Button
              color="primary"
              variant="contained"
              onClick={() => navigate("/home-region")}
            >
              Go to Banner Page
            </Button>
          </Box>
        </Box>
      )}
    </Box>
  );
}

export { mainMenu };
